import React, { useState, createContext, useContext } from 'react';
type Lang = 'ua' | 'ru';
type Translations = Record<string, {
  ua: string;
  ru: string;
}>;
const translations: Translations = {
  // Header / Nav
  nav_about: {
    ua: 'Про нас',
    ru: 'О нас'
  },
  nav_services: {
    ua: 'Послуги',
    ru: 'Услуги'
  },
  nav_advantages: {
    ua: 'Переваги',
    ru: 'Преимущества'
  },
  nav_faq: {
    ua: 'FAQ',
    ru: 'FAQ'
  },
  nav_contacts: {
    ua: 'Контакти',
    ru: 'Контакты'
  },
  nav_consultation: {
    ua: 'Консультація',
    ru: 'Консультация'
  },
  nav_order_consultation: {
    ua: 'Замовити консультацію',
    ru: 'Заказать консультацию'
  },
  // Hero
  hero_badge: {
    ua: 'Бухгалтерські послуги для бізнесу',
    ru: 'Бухгалтерские услуги для бизнеса'
  },
  hero_h1_1: {
    ua: 'Ведемо ваш облік.',
    ru: 'Ведём ваш учёт.'
  },
  hero_h1_2: {
    ua: 'Ви займаєтесь бізнесом.',
    ru: 'Вы занимаетесь бизнесом.'
  },
  hero_subtitle: {
    ua: 'Професійний бухгалтерський супровід для ФОП та ТОВ. Податкова звітність, зарплата, реєстрація — все під контролем.',
    ru: 'Профессиональное бухгалтерское сопровождение для ФЛП и ООО. Налоговая отчётность, зарплата, регистрация — всё под контролем.'
  },
  hero_cta_primary: {
    ua: 'Отримати консультацію',
    ru: 'Получить консультацию'
  },
  hero_cta_secondary: {
    ua: 'Наші послуги',
    ru: 'Наши услуги'
  },
  hero_trust_1: {
    ua: '10+ років досвіду',
    ru: '10+ лет опыта'
  },
  hero_trust_2: {
    ua: '300+ клієнтів',
    ru: '300+ клиентов'
  },
  hero_trust_3: {
    ua: '100% вчасно',
    ru: '100% вовремя'
  },
  hero_stat_label: {
    ua: 'Вчасна звітність',
    ru: 'Своевременная отчётность'
  },
  // About
  about_h2: {
    ua: 'Ми спеціалізуємося виключно на бухгалтерському обліку.',
    ru: 'Мы специализируемся исключительно на бухгалтерском учёте.'
  },
  about_p1: {
    ua: 'З 2013 року ми допомагаємо підприємцям та компаніям вести облік, подавати звітність та оптимізувати оподаткування.',
    ru: 'С 2013 года мы помогаем предпринимателям и компаниям вести учёт, подавать отчётность и оптимизировать налогообложение.'
  },
  about_p2: {
    ua: 'Ми розуміємо специфіку роботи з ДПС, знаємо всі зміни в законодавстві та готові взяти на себе всю паперову роботу, щоб ви могли зосередитися на розвитку свого бізнесу.',
    ru: 'Мы понимаем специфику работы с налоговой, знаем все изменения в законодательстве и готовы взять на себя всю бумажную работу, чтобы вы могли сосредоточиться на развитии своего бизнеса.'
  },
  about_stat1_label: {
    ua: 'Років досвіду',
    ru: 'Лет опыта'
  },
  about_stat2_label: {
    ua: 'Клієнтів',
    ru: 'Клиентов'
  },
  about_stat3_label: {
    ua: 'Звітів подано',
    ru: 'Отчётов подано'
  },
  about_stat4_label: {
    ua: 'Вчасно',
    ru: 'Вовремя'
  },
  about_caption: {
    ua: 'Професійний облік',
    ru: 'Профессиональный учёт'
  },
  // Services
  services_h2: {
    ua: 'Послуги',
    ru: 'Услуги'
  },
  services_subtitle: {
    ua: 'Повний спектр бухгалтерських послуг для вашого бізнесу.',
    ru: 'Полный спектр бухгалтерских услуг для вашего бизнеса.'
  },
  services_all: {
    ua: 'Всі послуги',
    ru: 'Все услуги'
  },
  services_footer: {
    ua: 'Індивідуальний підхід до кожного клієнта',
    ru: 'Индивидуальный подход к каждому клиенту'
  },
  svc1_title: {
    ua: 'Бухгалтерський облік',
    ru: 'Бухгалтерский учёт'
  },
  svc1_desc: {
    ua: 'Ведення обліку для ФОП та ТОВ на будь-якій системі оподаткування.',
    ru: 'Ведение учёта для ФЛП и ООО на любой системе налогообложения.'
  },
  svc1_price: {
    ua: 'від 1500 грн/міс',
    ru: 'от 1500 грн/мес'
  },
  svc2_title: {
    ua: 'Податкова звітність',
    ru: 'Налоговая отчётность'
  },
  svc2_desc: {
    ua: 'Підготовка та подання всіх видів звітності до ДПС, ПФУ та інших органів.',
    ru: 'Подготовка и подача всех видов отчётности в налоговую, ПФУ и другие органы.'
  },
  svc2_price: {
    ua: 'від 800 грн',
    ru: 'от 800 грн'
  },
  svc3_title: {
    ua: 'Реєстрація ФОП / ТОВ',
    ru: 'Регистрация ФЛП / ООО'
  },
  svc3_desc: {
    ua: 'Реєстрація бізнесу, вибір системи оподаткування, відкриття рахунку.',
    ru: 'Регистрация бизнеса, выбор системы налогообложения, открытие счёта.'
  },
  svc3_price: {
    ua: 'від 1000 грн',
    ru: 'от 1000 грн'
  },
  svc4_title: {
    ua: 'Зарплата та кадри',
    ru: 'Зарплата и кадры'
  },
  svc4_desc: {
    ua: 'Нарахування зарплати, ЄСВ, лікарняних та відпускних. Кадрове діловодство.',
    ru: 'Начисление зарплаты, ЕСВ, больничных и отпускных. Кадровое делопроизводство.'
  },
  svc4_price: {
    ua: 'від 500 грн/міс',
    ru: 'от 500 грн/мес'
  },
  svc5_title: {
    ua: 'Консультації з оподаткування',
    ru: 'Консультации по налогообложению'
  },
  svc5_desc: {
    ua: 'Аналіз податкового навантаження, оптимізація та планування для вашого бізнесу.',
    ru: 'Анализ налоговой нагрузки, оптимизация и планирование для вашего бизнеса.'
  },
  svc5_price: {
    ua: 'від 600 грн',
    ru: 'от 600 грн'
  },
  svc6_title: {
    ua: 'Відновлення обліку',
    ru: 'Восстановление учёта'
  },
  svc6_desc: {
    ua: 'Відновлення бухгалтерського обліку за попередні періоди. Виправлення помилок.',
    ru: 'Восстановление бухгалтерского учёта за предыдущие периоды. Исправление ошибок.'
  },
  svc6_price: {
    ua: 'Індивідуально',
    ru: 'Индивидуально'
  },
  // WhyChooseUs
  why_h2: {
    ua: 'Чому обирають нас',
    ru: 'Почему выбирают нас'
  },
  why1_title: {
    ua: 'Досвід та кваліфікація',
    ru: 'Опыт и квалификация'
  },
  why1_desc: {
    ua: 'Сертифіковані бухгалтери з 10+ роками практики. Постійно відстежуємо зміни в законодавстві.',
    ru: 'Сертифицированные бухгалтеры с 10+ годами практики. Постоянно отслеживаем изменения в законодательстве.'
  },
  why2_title: {
    ua: 'Дотримання термінів',
    ru: 'Соблюдение сроков'
  },
  why2_desc: {
    ua: 'Жодного штрафу за запізнілу звітність. Ми відстежуємо всі дедлайни та нагадуємо вам заздалегідь.',
    ru: 'Никаких штрафов за просроченную отчётность. Мы отслеживаем все дедлайны и напоминаем вам заранее.'
  },
  why3_title: {
    ua: 'Прозорість роботи',
    ru: 'Прозрачность работы'
  },
  why3_desc: {
    ua: 'Фіксована вартість послуг без прихованих платежів. Ви завжди знаєте, за що платите.',
    ru: 'Фиксированная стоимость услуг без скрытых платежей. Вы всегда знаете, за что платите.'
  },
  why4_title: {
    ua: 'Конфіденційність',
    ru: 'Конфиденциальность'
  },
  why4_desc: {
    ua: 'Повна конфіденційність ваших фінансових даних. Договір про нерозголошення з кожним клієнтом.',
    ru: 'Полная конфиденциальность ваших финансовых данных. Договор о неразглашении с каждым клиентом.'
  },
  // FAQ
  faq_h2: {
    ua: 'FAQ',
    ru: 'FAQ'
  },
  faq_subtitle: {
    ua: 'Відповіді на найпоширеніші питання про бухгалтерські послуги.',
    ru: 'Ответы на самые частые вопросы о бухгалтерских услугах.'
  },
  faq_ask: {
    ua: 'Задати своє питання',
    ru: 'Задать свой вопрос'
  },
  faq1_q: {
    ua: 'Чи потрібен бухгалтер ФОП на єдиному податку?',
    ru: 'Нужен ли бухгалтер ФЛП на едином налоге?'
  },
  faq1_a: {
    ua: 'Формально ФОП 1-3 групи може вести облік самостійно, але помилки у звітності призводять до штрафів. Бухгалтер гарантує правильність та вчасність подання всіх документів, а також допоможе оптимізувати оподаткування.',
    ru: 'Формально ФЛП 1-3 группы может вести учёт самостоятельно, но ошибки в отчётности приводят к штрафам. Бухгалтер гарантирует правильность и своевременность подачи всех документов, а также поможет оптимизировать налогообложение.'
  },
  faq2_q: {
    ua: 'Яка вартість бухгалтерського обслуговування?',
    ru: 'Какова стоимость бухгалтерского обслуживания?'
  },
  faq2_a: {
    ua: 'Вартість залежить від обсягу операцій та системи оподаткування. ФОП без найманих працівників — від 1500 грн/міс, ТОВ — від 3000 грн/міс. Точну ціну розраховуємо після аналізу вашої діяльності.',
    ru: 'Стоимость зависит от объёма операций и системы налогообложения. ФЛП без наёмных работников — от 1500 грн/мес, ООО — от 3000 грн/мес. Точную цену рассчитываем после анализа вашей деятельности.'
  },
  faq3_q: {
    ua: 'Як часто потрібно подавати звітність?',
    ru: 'Как часто нужно подавать отчётность?'
  },
  faq3_a: {
    ua: 'Залежить від системи оподаткування: ФОП на єдиному податку подає квартальну декларацію, платники ПДВ — щомісячну. Ми відстежуємо всі терміни та подаємо звітність вчасно.',
    ru: 'Зависит от системы налогообложения: ФЛП на едином налоге подаёт квартальную декларацию, плательщики НДС — ежемесячную. Мы отслеживаем все сроки и подаём отчётность вовремя.'
  },
  faq4_q: {
    ua: 'Чи працюєте з нерезидентами та іноземними компаніями?',
    ru: 'Работаете ли вы с нерезидентами и иностранными компаниями?'
  },
  faq4_a: {
    ua: 'Так, ми маємо досвід роботи з компаніями, що мають іноземних засновників, а також з підприємцями, які отримують дохід з-за кордону (Upwork, Fiverr, іноземні контракти).',
    ru: 'Да, у нас есть опыт работы с компаниями с иностранными учредителями, а также с предпринимателями, получающими доход из-за рубежа (Upwork, Fiverr, иностранные контракты).'
  },
  faq5_q: {
    ua: 'Що таке єдиний податок і яку групу обрати?',
    ru: 'Что такое единый налог и какую группу выбрать?'
  },
  faq5_a: {
    ua: 'Єдиний податок — спрощена система оподаткування для малого бізнесу. Вибір групи залежить від виду діяльності та обороту. На консультації ми допоможемо обрати оптимальний варіант саме для вас.',
    ru: 'Единый налог — упрощённая система налогообложения для малого бизнеса. Выбор группы зависит от вида деятельности и оборота. На консультации мы поможем выбрать оптимальный вариант именно для вас.'
  },
  faq6_q: {
    ua: 'Чи надаєте термінові консультації?',
    ru: 'Предоставляете ли срочные консультации?'
  },
  faq6_a: {
    ua: "Так, ми розуміємо, що податкові питання бувають невідкладними. Зв'яжіться з нами через Telegram або WhatsApp для термінової консультації.",
    ru: 'Да, мы понимаем, что налоговые вопросы бывают неотложными. Свяжитесь с нами через Telegram или WhatsApp для срочной консультации.'
  },
  // Contact
  contact_h2: {
    ua: 'Контакти',
    ru: 'Контакты'
  },
  contact_subtitle: {
    ua: "Залиште заявку, і наш бухгалтер зв'яжеться з вами для безкоштовної консультації.",
    ru: 'Оставьте заявку, и наш бухгалтер свяжется с вами для бесплатной консультации.'
  },
  contact_phone_label: {
    ua: 'Телефон',
    ru: 'Телефон'
  },
  contact_email_label: {
    ua: 'Email',
    ru: 'Email'
  },
  contact_office_label: {
    ua: 'Офіс',
    ru: 'Офис'
  },
  contact_form_title: {
    ua: "Форма зв'язку",
    ru: 'Форма связи'
  },
  contact_name_label: {
    ua: "Ім'я",
    ru: 'Имя'
  },
  contact_name_placeholder: {
    ua: 'Іван Петренко',
    ru: 'Иван Петренко'
  },
  contact_phone_input_label: {
    ua: 'Телефон',
    ru: 'Телефон'
  },
  contact_message_label: {
    ua: 'Повідомлення',
    ru: 'Сообщение'
  },
  contact_message_placeholder: {
    ua: 'Опишіть вашу ситуацію...',
    ru: 'Опишите вашу ситуацию...'
  },
  contact_submit: {
    ua: 'Відправити',
    ru: 'Отправить'
  },
  contact_privacy: {
    ua: 'Натискаючи кнопку, ви погоджуєтесь на обробку персональних даних',
    ru: 'Нажимая кнопку, вы соглашаетесь на обработку персональных данных'
  },
  contact_success_title: {
    ua: 'Заявку відправлено',
    ru: 'Заявка отправлена'
  },
  contact_success_subtitle: {
    ua: "Ми зв'яжемося з вами найближчим часом.",
    ru: 'Мы свяжемся с вами в ближайшее время.'
  },
  contact_error: {
    ua: "Помилка відправки. Спробуйте ще раз або зв'яжіться напряму.",
    ru: 'Ошибка отправки. Попробуйте ещё раз или свяжитесь напрямую.'
  },
  // Footer
  footer_desc: {
    ua: 'Професійні бухгалтерські послуги для ФОП та ТОВ. Податкова звітність, зарплата, реєстрація бізнесу.',
    ru: 'Профессиональные бухгалтерские услуги для ФЛП и ООО. Налоговая отчётность, зарплата, регистрация бизнеса.'
  },
  footer_nav_title: {
    ua: 'Навігація',
    ru: 'Навигация'
  },
  footer_contacts_title: {
    ua: 'Контакти',
    ru: 'Контакты'
  },
  footer_rights: {
    ua: 'Всі права захищено.',
    ru: 'Все права защищены.'
  },
  footer_privacy: {
    ua: 'Політика конфіденційності',
    ru: 'Политика конфиденциальности'
  },
  footer_terms: {
    ua: 'Умови використання',
    ru: 'Условия использования'
  }
};
interface LanguageContextType {
  lang: Lang;
  setLang: (lang: Lang) => void;
  t: (key: string) => string;
}
const LanguageContext = createContext<LanguageContextType>({
  lang: 'ua',
  setLang: () => {},
  t: key => key
});
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [lang, setLang] = useState<Lang>('ua');
  const t = (key: string): string => {
    const entry = translations[key];
    if (!entry) return key;
    return entry[lang] ?? key;
  };
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-328">
      {children}
    </LanguageContext.Provider>;
}
export function useLang() {
  return useContext(LanguageContext);
}